import { Component, OnInit } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { BsModalRef } from 'ngx-bootstrap/modal';


@Component({
  selector: 'app-payment-modal',
  templateUrl: './payment-modal.component.html',
  styleUrls: ['./payment-modal.component.scss'],
})
export class PaymentModalComponent implements OnInit {
  public loading: boolean = false;
  iframeUrl: SafeResourceUrl = '';

  constructor(
    private modalRef: BsModalRef,
  ) {

  }

  ngOnInit(): void {

  }

  close() {
    this.modalRef.hide();
  }
}
